module.exports = __webpack_public_path__ + "img/french-polynesia.79e6bcc2.png";